<template>
	<p>Rientrati a Domicilio</p>
</template>

<script>
export default {};
</script>

<style></style>
